module.exports = __webpack_public_path__ + "static/media/ReportSupportUserIcon.c02e61f2.svg";